import { DropdownButton } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const fieldHeight = 32
export const fieldFontSize = 13
export const fieldWidth = 290
export const ModalWidth = 344
export const DoubleModalWidth = 680
export const ModalHeight = screen.height * 0.5

export const ModalTabSectionsContainer = styled.div`
    margin-top: 16px;
    > div {
        display: flex;
        flex-flow: column;
        gap: 15px;
    }
`
export const ModalHeader = styled.div`
    border-radius: 4px 4px 0px 0px;
    background-color: var(--gray-900);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    color: var(--gray-0);
    cursor: move;
    line-height: 14px;
    font-size: 14px;
    padding: 8px 0;
    height: 30px;
`
export const ModalBody = styled.div<{ liveTheme?: string }>`
    height: 100%;
    overflow-y: auto;
    padding-bottom: 33px;

    background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};

    .tabs-header {
        display: grid;
        grid-template-columns: auto auto auto;
        gap: 10px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0px;
            cursor: pointer;
            color: var(--gray-800);

            div {
                font-size: 14px;
                font-weight: 600;
                text-transform: uppercase;
            }

            &.active {
                border-bottom: 2px solid #37a3ef;
            }

            &.inactive div {
                color: #37a3ef;
            }
        }
    }
`
export const ModalSideBody = styled(ModalBody)<{ height?: string; leftBorder?: boolean }>`
    width: 344px;
    margin: 0px;
    padding-bottom: 20px;
    height: ${({ height }) => height || 'auto'};
    background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};

    .msg-highlighted-fields {
        padding: 0 20px;
    }

    ${({ leftBorder }) =>
        leftBorder &&
        css`
            border-left: 1px solid var(--gray-400);
        `}
`
export const ModalFooter = styled.div<{ liveTheme?: string }>`
    display: flex;
    padding: 8px 40% 8px 20px;
    gap: 8px;
    border-top: 1px solid var(--gray-300);
    font-weight: bold;
    height: 48px;

    background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};
`
export const ModalFooterContainer = styled.div`
    display: flex;
    gap: 8px;
`
export const ModalButton = styled.button<{ styleType: 'action' | 'cancel' }>`
    border-radius: 3px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;

    :disabled {
        background-color: var(--blue-400);
        cursor: not-allowed;

        :hover {
            background-color: var(--blue-400);
            opacity: initial !important;
        }
    }

    :disabled:not(#btn-start) {
        border: 1px solid var(--blue-500);

        :hover {
            border: 1px solid var(--blue-500);
        }
    }

    ${({ styleType, theme }) => {
        switch (styleType) {
            case 'action':
                return css`
                    color: white;
                    background-color: var(--blue-500);
                    border: none;
                    &:hover {
                        opacity: 0.9;
                    }
                `
            case 'cancel':
                return css`
                    color: var(--gray-800);
                    border: 1px solid var(--gray-500);
                    background-color: transparent;
                    &:hover {
                        background-color: var(--gray-200);
                    }
                `
        }
    }}

    .fa-arrow-right {
        padding-top: 0;
    }
`
export const StyledModalContainer = styled.div<{ isDouble: boolean }>`
    background-color: ${({ theme }) => theme['light-shadow']};
    box-shadow: 0 0px 25px 0 rgba(23, 31, 51, 0.5);
    border-radius: 4px;
    font-size: 13px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    width: ${props => (props.isDouble ? DoubleModalWidth : ModalWidth)}px;
    height: ${ModalHeight}px;
    overflow-y: hidden;
    position: absolute;
`
export const inputStyles = css`
    .required-field-message {
        color: orange;
    }
    .modal-field-label {
        font-size: 13px;
        display: flex;
        flex-flow: column;
        margin-bottom: 3px;
        color: var(--gray-800);
    }
    .input-uom {
        display: flex;
        input {
            /* margin-right: 10px; */
            font-size: 13px;
        }
        .live-select.form-group {
            margin: 0px !important;
            border-radius: 3px;
            width: 20%;
        }
    }
    .select-value-uom {
        display: flex;
        width: 100%;
        .select-value {
            width: 100%;
            margin-right: 10px;
            .Select-control {
                width: 100%;
            }
        }
        .select-uom {
            width: 20%;
            .Select-control {
                width: 100%;
            }
        }
    }
    .input-date-time {
        display: grid;
        grid-template-columns: 65% 1fr;
        gap: 1rem;
    }
    input {
        border-radius: 3px;
        box-shadow: none;
        border: 1px solid var(--gray-500);
        background-color: var(--gray-100);
        color: var(--gray-800);
        height: ${fieldHeight}px;
    }
    .live-select.form-group {
        margin: 0px !important;
        border-radius: 3px;
        width: 100%;
    }
`
export const ModalContent = styled.div`
    ${({ theme }) => css`
        color: ${theme['text-color']};
        width: ${ModalWidth};
        height: 100%;
        overflow-y: auto;
        .modal-tabsections {
            margin: 0 20px;
            .input-date-time {
                display: grid;
                grid-template-columns: 65% 1fr;
                gap: 1rem;
            }
        }
        .modal-subsection {
            display: flex;
            flex-flow: column;
            margin-bottom: 10px;
            .modal-subsection-header {
                margin-bottom: 10px;
                display: flex;
                .modal-subsection-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: ${theme['text-color']} !important;
                }
                .modal-subsection-minimize {
                    cursor: pointer;
                    margin-right: 10px;
                    color: ${theme['link-button']};
                }
            }
            .modal-subsection-content {
                ${inputStyles}
            }
        }
    `};
`
export const StyledModalField = styled.div<{ enabled: boolean; liveTheme?: string }>`
    ${({ enabled }) =>
        !enabled &&
        css`
            /* opacity: 0.25; */
            pointer-events: none;
            .custom-date-picker {
                .custom-date {
                    color: var(--gray-700) !important;
                }
            }
            input {
                color: var(--gray-700) !important;
            }
        `}
    width: 100%;
    display: flex;
    flex-flow: column;
    ${inputStyles}

    .masked-input {
        &:disabled {
            color: var(--gray-600);
            background-color: ${({ liveTheme }) =>
                liveTheme === 'dark' ? 'var(--gray-300)' : 'var(--gray-200)'} !important;
            box-sizing: border-box;
            border-radius: 3px;
        }
    }

    .Select-placeholder {
        font-size: 13px !important;
        color: var(--gray-700) !important;
        height: ${fieldHeight}px;
        width: 290px;
    }
    .Select-option:not(.is-focused) {
        background-color: var(--gray-200) !important;
    }
    .Select-option.is-focused {
        background-color: var(--gray-300) !important;
    }
    .Select--single > .Select-control .Select-value {
        max-width: 260px;
    }
    .Select:not(.is-disabled).has-value.Select--single > .Select-control .Select-value .Select-value-label {
        color: var(--gray-800);
    }
    .has-value.Select--single.is-disabled > .Select-control .Select-value .Select-value-label {
        color: var(--gray-700) !important;
    }
    .Select.is-disabled > .Select-control {
        box-shadow: 0px 0px ${({ theme }) => theme['input-disabled']} !important;
        background-color: ${({ liveTheme }) =>
            liveTheme === 'dark' ? 'var(--gray-300)' : 'var(--gray-200)'} !important;
    }
    .Select-control {
        border-radius: 3px !important;
        border: 1px solid var(--gray-500);
        box-shadow: 0px -37px ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')} inset !important;
        font-size: 14px;
        .Select-placeholder {
            color: var(--gray-600) !important;
            font-size: ${fieldFontSize}px !important;
        }
    }
    .Select-input {
        width: 100%;
        height: ${fieldHeight}px;
        border-radius: 3px !important;
    }
    ${({ enabled }) =>
        enabled &&
        css`
            .Select-arrow {
                border-color: #37a3ef transparent transparent;
            }
        `}
    .Select-input {
        &:focus {
            background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};
        }
        input {
            padding: 0px;
            border: none;
            background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};
        }
    }
    input[disabled] {
        cursor: not-allowed;

        color: var(--gray-700) !important;
        background-color: ${({ liveTheme }) =>
            liveTheme === 'dark' ? 'var(--gray-300)' : 'var(--gray-200)'} !important;
    }
    .input-checkbox {
        color: var(--gray-800);

        input[type='checkbox']:not(.browser-default-input-style):disabled,
        input[type='checkbox']:not(.browser-default-input-style):disabled:checked::after {
            background-color: var(--blue-500);
            opacity: 1 !important;
        }

        input[type='checkbox']:not(.browser-default-input-style) {
            width: 14px;
            height: 14px;
            border-radius: 3px;
            border: 2px solid var(--gray-600);

            :checked {
                border-color: var(--blue-500);
                background-color: var(--blue-500);

                ::after {
                    color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')} !important;
                }
            }
        }

        span {
            color: var(--gray-800);
        }
    }
    input {
        background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-200)' : 'white')};
    }
    .input-normal .error-message-final-md {
        display: flex;
        gap: 6px;
        margin-top: 6px;
        color: #d9534f;

        i {
            margin-top: 2px;
        }

        span {
            width: 110px;
        }
    }
    .input-normal textarea {
        border: 1px solid var(--gray-500) !important;
        color: var(--gray-800) !important;
        background-color: inherit;

        &:disabled {
            color: var(--gray-700);
            background-color: ${({ liveTheme }) => (liveTheme === 'dark' ? 'var(--gray-300)' : 'var(--gray-200)')};
        }
    }
    .Select-option {
        background-color: ${({ theme }) => theme['gray-lighter']};
        color: var(--gray-800) !important;
    }
`
export const CustomDatePickerContainer = styled.div<{ isDisabled?: boolean; liveTheme: string }>`
    display: flex;
    flex-direction: column;
    position: relative;
    .custom-input-wrapper {
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid var(--gray-500);
        background-color: transparent;
        padding: 1rem;
        border-radius: 3px;
        cursor: pointer;
        color: var(--gray-800);

        &.isDisabled {
            color: var(--gray-700) !important;
            background-color: ${({ liveTheme }) =>
                liveTheme === 'dark' ? 'var(--gray-300)' : 'var(--gray-200)'} !important;
            box-sizing: border-box;
            border-radius: 3px;
            pointer-events: none;
        }
        i {
            position: absolute;
            right: 11px;
            color: #37a3ef;
        }

        .react-datepicker-wrapper {
            .react-datepicker__input-container {
                z-index: 1;

                input {
                    border: none;
                    width: 100%;
                    height: 28px;
                    cursor: pointer;
                    color: ${({ isDisabled }) => (isDisabled ? 'var(--gray-700)' : 'var(--gray-800)')};
                    background-color: transparent;

                    ::placeholder {
                        color: var(--gray-600);
                    }
                }
            }
        }
        .react-datepicker-popper {
            position: fixed !important;

            .react-datepicker {
                z-index: 1;
                position: absolute;
                width: 198px;

                .react-datepicker__triangle {
                    left: -13px !important;
                }

                .react-datepicker__month-container {
                    width: 100%;

                    .react-datepicker__header {
                        width: 196px;
                        background-color: var(--gray-0);
                        .react-datepicker__day-name {
                            width: 198px;
                        }
                    }

                    .react-datepicker__month {
                        width: 100%;
                        margin: 0 !important;
                    }
                }
            }
        }
    }
`
export const CustomMeasureSelectContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    position: relative;
    margin-left: 0.25rem;
    margin-bottom: 0.25rem;
    font-size: 13px;
    .dropdown-menu {
        max-width: fit-content;
        min-width: fit-content !important;
    }
    i {
        color: #37a3ef;
        position: absolute;
        right: 0;
        font-size: 13px;
        pointer-events: none;
    }
`
export const CustomDropdownButton = styled(DropdownButton)`
    padding: 0;
    background: transparent;
    border: none;
    margin: 0;
    color: #37a3ef;
    font-weight: bold;
    font-size: 13px;
`
export const StyledMissingInformationField = styled.div`
    margin-top: 10px;

    .content-missing-information {
        .fa-exclamation-triangle,
        .missing-information-label {
            color: var(--red-700);
        }
    }

    .container-missing-information {
        padding: 8px 8px 8px 16px;
        border-radius: 4px;
        border: 1px solid var(--yellow-700);
        background: var(--yellow-200);

        header {
            display: flex;
            justify-content: space-between;

            .fa-times {
                cursor: pointer;
                color: var(--gray-800);
            }
        }

        .missing-information-field-text {
            font-weight: normal;
            font-size: 12px;
            margin-top: 4px;
            p {
                font-size: 11.8px;
                color: var(--gray-800);
            }
        }

        .btn-link-and-refresh {
            display: flex;
            justify-content: space-between;
            gap: 16px;

            button {
                color: white;
                padding: 4px 0;
                background: var(--blue-500);
                border-radius: 3px;
                width: 131px;
                border: none;
                font-weight: 600;
                i {
                    font-weight: 600;
                    margin-right: 8px;
                }

                a {
                    text-decoration: none;
                    font-weight: 600;
                    color: #fff;
                }

                :hover {
                    background-color: var(--blue-400);
                }
            }

            .btn-refresh {
                border: 1px solid var(--gray-500);
                color: var(--gray-800);
                background-color: transparent;
            }
        }
    }

    .content-missing-information {
        display: flex;
        gap: 4px;

        .fa-exclamation-triangle {
            display: flex;
            align-items: center;
        }

        .missing-information-label {
            font-weight: bold;
            font-size: 13px;
        }
    }
`
export const BadgeContainer = styled.div<{ bgColor: string }>`
    display: flex;
    align-items: center;
    gap: 4px;

    margin-left: 4px;
    padding: 3px 6px;

    border-radius: 4px;

    background-color: ${({ bgColor }) => bgColor || 'transparent'};

    i {
        color: var(--gray-0);
    }

    p {
        font-weight: 700;
        margin: 0;
        cursor: default;

        color: var(--gray-0);
    }
`

export const ModalPositioningContainer = styled.div<{ leftPosition: number; topPosition: number }>`
    left: ${({ leftPosition }) => leftPosition}px;
    top: ${({ topPosition }) => topPosition - 6}px;
    position: relative;
`
export const ModalTooltipIcon = styled.i<{ leftPosition: number; topPosition: number }>`
    position: fixed;
    top: ${({ topPosition }) => topPosition - 6}px;
    font-size: 20px;
    color: var(--gray-900);
    cursor: initial;
    left: ${({ leftPosition }) => leftPosition}px;
`

export const CustomUnitLabel = styled.div`
    padding: 0;
    color: #37a3ef;
    font-weight: bold;
`
export const InformationIcon = styled.div`
    color: ${theme['link-color']};
    cursor: default;
    margin-left: 8px;
    padding-bottom: 2px;
`
export const CustomMeasureWithTooltip = styled.div`
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
`

export const RestrictedPerformanceHeader = styled.div`
    justify-content: space-between;
    display: flex;
    color: var(--gray-800);

    i {
        color: #c8ccd4;
        cursor: pointer;
        margin-top: 2px;
    }
    i:hover {
        color: var(--red-700);
        cursor: pointer;
    }
`
export const RestrictedMessage = styled.div`
    padding: 10px;
    i {
        text-align: center;
        justify-content: center;
        display: flex;
        font-size: 24px;
        margin-bottom: 14px;
        color: var(--gray-600);
    }
`

export const RestrictedTitle = styled.div`
    font-weight: normal;
    color: var(--gray-800);
    text-align: center;
    margin-bottom: 3px;
`

export const RestrictedContent = styled.div`
    text-align: center;
    color: var(--gray-600);
    font-style: italic;
`

export const InputRadioContainer = styled.div<{ showRadioWhenDisabled?: boolean }>`
    width: max-content;
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
        width: 16px;
        height: 16px;
        border-radius: 100%;
        &:disabled::after {
            background-color: ${({ showRadioWhenDisabled }) =>
                showRadioWhenDisabled ? 'var(--blue-500) !important' : 'none'};
        }
    }

    label {
        color: var(--gray-800);
        font-family: 'Source Sans Pro';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        padding: 0;
    }
`
